// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectSilosInitWaitingMessage, selectSilosInStore, selectSilosPageLoading } from '../_selectors/silo.selectors';

export class SilosDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectSilosPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectSilosInitWaitingMessage)
		);

		this.store.pipe(
			select(selectSilosInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
